exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".landing-hero-image{margin:0 -48px;background-color:\"#4B4B4B\"}.landing-hero-image .backgroundImage{height:100%;width:100%;background-size:102%;background-position:center}.landing-hero-image .backgroundImage .hero-content{max-width:1420px;color:#fff}.landing-hero-image .backgroundImage .landingPageTitle{color:#646464;font-size:25px;font-weight:600}.landing-hero-image .backgroundImage .mailTitle{font-size:33px;color:#000}.landing-hero-image .sub-nav-link-button{padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/PolicyReview/HeroImage.scss
// module id = 7549
// module chunks = 101